import styles from "./Hero.module.css";

import heroImage from "../../assets/images/Hero/Hero.avif";

function Hero() {
  return (
    <div
      className={styles.heroContainer}
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className={styles.overlay}>
        <div className={styles.heroContent}>
          <p className={styles.heroPretitle}>Genuss für jeden Anlass</p>
          <h1 className={styles.heroTitle}>Foodosia Catering</h1>
          <p className={styles.heroSubtitle}>
            Das Event beginnt mit dem ersten Bissen.
          </p>
          <div className={styles.heroButtons}>
            <div
              role="button"
              onClick={() => (window.location.href = "#card-menu")}
            >
              Unsere Angebote
            </div>
            <div
              role="button"
              onClick={() => (window.location.href = "#card-impression")}
            >
              Impressionen
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
